import React from 'react';
import styled from 'styled-components';

import Top from '../top';
import Section from '../global/section';

const StyledOpener = styled.div`
	text-align: center;
	.quote {
		font-family: ${(p) => p.theme.fonts.serifBody};
		width: 80%;
		@media all and (max-width: 668px) {
			width: 100%;
		}
		margin: 0 auto;
		font-style: italic;
		font-size: 1.2rem;
		margin-bottom: 1rem;
	}
	.top {
		text-transform: uppercase;
		font-weight: 400;
	}
`;

export default ({ author, quote }) => {
	return (
		<StyledOpener>
			<Section>
				<p className="quote">“{quote}”</p>
				<Top className="top" color="blue">
					- {author}
				</Top>
			</Section>
		</StyledOpener>
	);
};
